<template>
  <div>
    <div>
      <b>{{ getUserNames(email.users)}}</b>
    </div>
    <div style="font-size: 0.9em">
      <b>From: </b> <span style="color: #5e5e5e">{{ email.fromAddress }}</span>
    </div>
    <div style="font-size: 0.9em">
      <b>To: </b> <span style="color: #5e5e5e">{{ email.toAddress }}</span>
    </div>
    <div style="font-size: 0.9em">
      <b>Date and Time: </b>
      <span style="color: #5e5e5e">{{ email.date }}</span>
    </div>
    <br />
    <div v-html="sanitizedEmailBody(email.bodyText)"></div>
    <v-tooltip location="bottom" :text="threeDotsText">
      <template v-slot:activator="{ props }">
        <span
          v-if="showThreeDots(email.bodyText)"
          v-bind="props"
          @click="toggleGmailQuote(email.messageId)"
          class="quote"
        ></span>
      </template>
    </v-tooltip>
    <div
      v-if="gmailQuoteVisible"
      class="gmail-quote"
      v-html="sanitizedEmailBody(email.bodyText, true)"
    ></div>
    <br /><br v-if="!gmailQuoteVisible" />
    <div v-if="this.mediaData.length > 0" class="hp"></div>
    <br />
    <div v-if="this.mediaData.length > 0">
      <b
        >{{ this.mediaData.length }}
        {{ this.mediaData.length === 1 ? "Attachment" : "Attachments" }}</b
      >
    </div>
    <div v-if="this.mediaData.length > 0">
      <span v-for="media in this.mediaData" :key="media.media_id">
        <v-img
          v-on:click="openImg(getFileUrl(email.email_id, media.media_id))"
          v-if="media.content_type != 'application/pdf'"
          max-height="150"
          max-width="250"
          :src="getFileUrl(email.email_id, media.media_id)"
          class="image-wtih-hover"
        >
        </v-img>
        <v-icon
          v-if="media.content_type === 'application/pdf'"
          style="font-size: 50px; max-width: 250px; max-height: 150px"
          size="50" color="red"
          v-on:click="openImg(getFileUrl(email.email_id, media.media_id))"
        >
          mdi-file-pdf-box
        </v-icon>
        <video
          :src="getFileUrl(email.email_id, media.media_id)"
          controls
          v-if="media.content_type == 'video/mp4'"
          class="video-element"
        ></video>
        <a @click="downloadFile(email.email_id, media.media_id)">
          <i class="mdi mdi-download"></i>
          <span class="file-name">{{
           getFileName(media.file_name)
          }}</span>
        </a>
        <br />
      </span>
    </div>
    <br v-if="this.mediaData.length > 0" />
    <v-btn @click="replyToEmail(email.messageId)" outlined class="reply-btn">
      <v-icon left> mdi-reply </v-icon>
      Reply
    </v-btn>
    <br /><br />
    <template v-if="replyActivated && currentMessageId === email.messageId">
      <div class="reply-container">
        <div>
          <v-file-input
            ref="uploader"
            accept="image/png, image/jpeg, image/bmp, image/gif, application/pdf, video/mp4"
            label="Upload Files"
            variant="underlined"
            multiple
            show-size
            @change="onFileChanged"
            truncate-length="15"
          ></v-file-input>
        </div>

         <v-form v-model="valid" style="display: flex; gap: 10px; margin-bottom: -3px; margin-top: 5px;">
            <v-text-field v-model="cc"  label="CC" type="email" style="max-width: 150px;" :rules="RULES.EMAIL" variant="outlined" density="compact" ></v-text-field>
            <v-text-field v-model="bcc" label="BCC" type="email" style="max-width: 150px;" :rules="RULES.EMAIL" variant="outlined" density="compact" ></v-text-field>
          </v-form>

        <v-textarea
          v-model="message"
          @focus="focused = true"
          @blur="focused = false"
          rows="1"
          auto-grow
          filled
          rounded
          variant="solo-filled"
          placeholder="Type message"
          ref="textarea"
          id="vtextarea"
        >
          <template v-slot:append-inner>
            <v-icon
              v-show="valid"
              :style="sendStyle"
              @click="
                submitForm(
                  email.threadId,
                  email.messageId,
                  email.subject,
                  index
                )
              "
              @mouseup="sendStyle = 'margin-right: 5px'"
              @mousedown="
                sendStyle = 'margin-right: 5px; background-color: #d3d3d3'
              "
              :color="focused ? 'primary' : 'dark'"
            >
              mdi-send
            </v-icon>

            <v-icon :color="focused ? 'primary' : 'dark'">
              {{ "mdi-email" }}
            </v-icon>
          </template>
        </v-textarea>

        <!-- Close button -->
        <span class="reply-close" @click="closeReply">&times;</span>
      </div>
      <br />
    </template>
  </div>
</template>


<script>
import axios from "axios";
import { mapGetters } from "vuex";
import MiscService from "@/services/miscService";
import DOMPurify from "dompurify";
import { RULES } from "../constants/validationRules.js";

export default {
  name: "EmailMessage",
  data: () => ({
    to: "",
    gmailQuoteVisible: false,
    replyActivated: false,
    currentMessageId: "",
    message: "",
    sendStyle: "margin-right: 5px",
    cc: "",
    bcc: "",
    mediaData: [],
    selectedFiles: null,
    focused : false,
    RULES,
    valid: false,
  }),
  computed: {
    ...mapGetters("frontdesk", ["current_contact","odFilterSelectedValue","getOdTag","isODFilterContact"]),
    ...mapGetters("people", ["getUserNames"]),
    threeDotsText() {
      return this.gmailQuoteVisible
        ? "Hide expanded content"
        : "Show trimmed content";
    },
  },
  methods: {
    sanitizedEmailBody(bodyText, isQuote = false) {
      let content;
      if (isQuote) {
        content = this.gmailQuoteContent(bodyText);
      } else {
        content = this.preGmailQuoteContent(bodyText);
      }
      return DOMPurify.sanitize(content);
    },
    preGmailQuoteContent(bodyText) {
      // Extract content before the gmail_quote div
      const endIndex = bodyText.indexOf('<div class="gmail_quote">');
      if (endIndex === -1) {
        return bodyText;
      }
      return bodyText.substring(0, endIndex);
    },
    showThreeDots(bodyText) {
      // Check if the email body contains the specified tag
      return bodyText.includes('<div class="gmail_quote">');
    },
    toggleGmailQuote(messageId) {
      this.gmailQuoteVisible = !this.gmailQuoteVisible;
    },
    gmailQuoteContent(bodyText) {
      // Extract content within the gmail_quote div
      const startIndex = bodyText.indexOf('<div class="gmail_quote">');
      const endIndex = bodyText.lastIndexOf("</div>");
      return bodyText.substring(startIndex, endIndex + 6);
    },

    async downloadFile(emailId, mediaId) {
      try {
        const fileUrl = this.getFileUrl(emailId, mediaId);
        const a = document.createElement("a");
        a.href = fileUrl;
        a.download = fileUrl.split("/").pop() || "attachment";
        a.rel = "noopener";
        a.target = "_blank";
        a.click();
      } catch (error) {
        console.error("Error downloading file:", error);
      }
    },
    getFileName(fileName) {
      const parts = fileName.split("/");
      const lastPart = parts[parts.length - 1] || fileName;
      const index = lastPart.indexOf("_");
      return index !== -1
        ? lastPart.substring(index + 1)
        : lastPart;
    },
    replyToEmail(messageId) {
      this.replyActivated = true;
      this.currentMessageId = messageId;
    },
    async submitForm(threadId, messageId, subject, index) {
      // Combine the fields into an object to send to the backend
      let has_attachment = false;
      const formData = new FormData();

      if (this.selectedFiles && this.selectedFiles.length > 0) {
        has_attachment = true;

        for (var i = 0; i < this.selectedFiles.length; i++) {
          formData.append("files", this.selectedFiles[i]);
        }
      } else if (this.message == "") {
        return;
      }

      const subject_ = subject.startsWith("Re: ") ? subject : `Re: ${subject}`;
      const body = this.Emails[index].bodyText;

      const message_ID = this.Emails[index].email_ref;
      let references = "";

      for (let i = 0; i <= index; i++) {
        const ref = this.Emails[i].email_ref;
        references += `${ref}`;
        if (i < index) {
          references += " "; // Add a space between each reference
        }
      }

      // console.log("New formated Date = ",this.formatDate(this.Emails[index].date));
      const gmail_attr = `On ${this.formatDate(this.Emails[index].date)} ${
        this.getUserNames(this.Emails[index].users)
      } &lt;<a href="mailto:${encodeURIComponent(this.Emails[index].fromAddress)}">${
        this.Emails[index].fromAddress
      }</a>&gt; wrote:`;
      console.log("gmail_attr = ", gmail_attr);
      //  console.log('current current_contact selected = ',this.current_contact);
      console.log("Email : ", this.Emails[index]);

      //  formData.append('to', this.current_contact.email);
      if (this.Emails[index].direction ==="sent") {
        this.to = this.Emails[index].toAddress;
      } else {
        this.to = this.Emails[index].fromAddress;
      }
      formData.append("to", this.to);
      formData.append("subject", subject_);
      formData.append("cc", this.cc);
      formData.append("bcc", this.bcc);
      formData.append("message", this.message);
      formData.append("has_attachment", has_attachment);
      formData.append("threadId", threadId);
      formData.append("messageId", messageId);
      formData.append("references", references);
      formData.append("message_ID", message_ID);
      formData.append("gmail_attr", gmail_attr);
      formData.append("body", body);
      formData.append("users", JSON.stringify(this.email.users));
      formData.append("isReply", true); // Reply to an email

       if(this.odFilterSelectedValue && this.isODFilterContact(this.current_contact.contact_id)){ // also check isContact is from OD
        if(this.getOdTag && this.getOdTag.enable_auto){
          const tagId = this.getOdTag.tag_id;
          formData.append("tag", tagId);
        }
      }

      let options = {
        method: "POST",
        url: process.env.VUE_APP_API_URL + "/api/mail/profile/sendMail",
        headers: {
          "Content-type": "multipart/form-data",
        },
        data: formData,
      };

      try {
        await axios.request(options);
        this.cc = "";
        this.bcc = "";
        this.message = "";
        this.replyActivated = false;
        this.selectedFiles = null;
        this.$refs.uploader?.reset();
      } catch (error) {
        console.error("Failed to send email:", error);
      }
    },
    closeReply() {
      this.replyActivated = false;
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const options = {
        weekday: "short",
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      };
      const formattedDate = date.toLocaleDateString("en-US", options);
      // console.log("formattedDate = ",formattedDate);
      return formattedDate.replace(/,(?=[^,]*$)/, " at");
    },
    getFileUrl(email_id, media_id) {
      console.log("reached getFileUrl");
      const url = MiscService.getEmailMediaUrl(email_id, media_id);
      console.log("url ", url);
      return url;
    },
    openImg: function (src) {
      console.log("src = ", src);
      window.open(src, "_blank");
    },
    async getMedias(email_id) {
      const mediaData = await MiscService.getMediasForEmail(email_id);
      console.log("email_id = ", email_id);
      console.log("mediaData = ", mediaData);

      this.mediaData = mediaData.data;
      return mediaData.data;
    },
    onFileChanged(event) {
      if (event == null) return;
      const files = event.target?.files || event;
      if (!files || files.length === 0) return;
      if (files.length > 8) {
        alert("Max number of files that can be attached is 8");
        this.$refs.uploader?.reset();
        return;
      }
      console.log("files are:", files);
      this.selectedFiles = files;
    },

    // b64toBlob(b64Data, contentType='', sliceSize=512) {
    //  const byteCharacters = atob(b64Data);
    // const byteArrays = [];

    // for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    //   const slice = byteCharacters.slice(offset, offset + sliceSize);

    //   const byteNumbers = new Array(slice.length);
    //   for (let i = 0; i < slice.length; i++) {
    //     byteNumbers[i] = slice.charCodeAt(i);
    //   }

    //   const byteArray = new Uint8Array(byteNumbers);
    //   byteArrays.push(byteArray);
    // }

    // const blob = new Blob(byteArrays, {type: contentType});
    // return blob;
    // }
  },
  props: {
    email: Object,
    Emails: Array,
    index: Number,
  },
  created() {
    this.getMedias(this.email.email_id);
  },
};
</script>

<style scoped>
.quote {
  display: inline-block;
  background-image: url(https://www.gstatic.com/images/icons/material/system_gm/1x/more_horiz_black_20dp.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: 20px;
  height: 11px;
  width: 24px;
  opacity: 0.71;
  cursor: pointer;
  background-color: #f1f1f1;
  border: 1px solid #ddd;
  text-align: center;
  outline: none;
  position: relative;
  overflow: hidden;
}

.quote:hover {
  background-color: #eaeaea;
}

.reply-btn {
  border: 1px solid black;
  /* margin-left: 150vw; Push the button to the right */
}

.reply-container {
  border: 1px solid #ccc; /* Outline border */
  padding: 10px; /* Add padding for spacing */
  border-radius: 5px; /* Add rounded corners */
  position: relative; /* Required for absolute positioning of the close button */
}

/* Style for the close button */
.reply-close {
  position: absolute;
  top: 5px;
  right: 5px;
  padding: 5px;
  cursor: pointer;
  font-size: 25px;
}

.hp {
  width: 100%;
  border-top: 1px dotted #d8d8d8;
}

.image-wtih-hover {
  cursor: pointer;
}

.video-element {
  max-height: 150px;
  max-width: 250px;
}
</style>